export const config = {
  isMosaic: true,
};
export default config;

